import React from 'react'

export default function HeaderMore() {
    return (
        <div id= 'main2'>
            <div className='header-heading'>
            <div className='header-btns'>
                </div>
            </div>

        </div>
    )
}
